import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "oklch(0.98 0.003 250 / 0.6)",
          "--normal-text": "var(--foreground)",
          "--normal-border": "transparent",
          "--border-radius": "var(--radius)",
          "--success-bg": "oklch(0.98 0.003 250 / 0.6)",
          "--success-text": "var(--foreground)",
          "--success-border": "transparent",
          "--error-bg": "oklch(0.98 0.003 250 / 0.6)",
          "--error-text": "var(--destructive)",
          "--error-border": "transparent",
          "--info-bg": "oklch(0.98 0.003 250 / 0.6)",
          "--info-text": "var(--foreground)",
          "--info-border": "transparent",
          "--warning-bg": "oklch(0.98 0.003 250 / 0.6)",
          "--warning-text": "var(--foreground)",
          "--warning-border": "transparent",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "!backdrop-blur-3xl !backdrop-saturate-150 !border !border-white/25 dark:!border-white/18 !shadow-2xl !py-3 !px-4 !text-sm !gap-2",
          actionButton: "!bg-primary !text-primary-foreground !text-xs !font-medium !rounded-md !px-3 !py-1.5",
          title: "!text-sm !font-medium",
          description: "!text-xs !text-muted-foreground",
          success: "[&>svg]:!text-primary",
          error: "[&>svg]:!text-destructive",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
